"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthorizationProvider = void 0;
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var selectors_1 = require("../redux/selectors");
var AuthorizationProvider = function (_a) {
    var children = _a.children;
    var isAuthRedux = (0, react_redux_1.useSelector)(selectors_1.adminSelector).isAuth;
    var isAuthSession = sessionStorage.getItem('isAuth');
    var navigate = (0, react_router_dom_1.useNavigate)();
    var location = (0, react_router_dom_1.useLocation)();
    react_1.default.useEffect(function () {
        if (!isAuthRedux && !isAuthSession) {
            navigate('/admin');
        }
        if ((isAuthRedux || isAuthSession) && location.pathname === '/admin') {
            navigate('/admin/cars');
        }
    }, [isAuthRedux, location.pathname]);
    return react_1.default.createElement(react_1.default.Fragment, null, children);
};
exports.AuthorizationProvider = AuthorizationProvider;
